import { Card, CardContent, Typography, Box } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import styles from "./SurveyResponseRatingCard.module.scss";

const Pill = ({ yes, value }) => (
    <div className={`${styles.pill} ${yes ? styles.yes : styles.no}`}>
        {yes ? (
            <CheckCircleRoundedIcon className={styles.icon} />
        ) : (
            <CancelRoundedIcon className={styles.icon} />
        )}
        {typeof value === "string" ? (
            <div className={styles.valueGroup}>
                <span className={styles.valueLabel}>{value.split(" ")[0]}</span>
                <span className={styles.valueNumber}>{value.split(" ")[1]}</span>
            </div>
        ) : (
            value
        )}
    </div>
);

const SurveyResponseRatingCard = ({ title, description, yesPct, noPct }) => {
    return (
        <Card className={styles.card}>
            <CardContent className={styles.cardContent}>
                <Typography variant="subtitle2" className={styles.title}>
                    {title}
                </Typography>

                <Typography variant="body2" className={styles.description}>
                    {description}
                </Typography>

                <div className={styles.pillRow}>
                    <Pill yes value={`Yes ${yesPct}%`} />
                    <Pill value={`No ${noPct}%`} />
                </div>
            </CardContent>
        </Card>
    );
};

export default SurveyResponseRatingCard;
